import React from 'react'
import { company, growth, } from '../../assets'


const Journey = () => {
  return (
    <div>
      
      <div className='py-10' >
        <div className="py-10 px-40 relative flex flex-col justify-center">
          <h2 className="font-poppins font-semibold text-center text-[40px] text-black relative after:content-[''] after:block after:w-12 after:h-[2px] after:bg-red-500 after:absolute after:left-1/2 after:bottom-0 after:transform after:-translate-x-1/2">
            Our Journey
          </h2>

        </div>
        <div className='grid grid-cols-2' >
          <div>
            <h3>Company’s profile</h3>
            <p>
            Mainlogix Technology Inc is an Internet of Things company in Delaware (United State) with Registration Number - 7566889, Nova Scotia (Canada) with Registration Number - 4526783 & Lagos, Nigeria with Registration Number (1846913). Mainlogix is a pioneering IoT company at the forefront of innovation, seamlessly integrating Smart Home, automation and advanced technology. Our comprehensive solutions span various domains, including Remote Patient Monitoring, Telemedicine, Mobile Health, Assisted Living, and Home Automation. With a user-centric focus, Mainlogix enhances smart home management, healthcare accessibility, and seniors' autonomy, leading to improved living standards and well-being. Automation comprises a wide range of  solutions for monitoring, controlling, securing, managing, and automating functions and  scenarios. It can also be used to monitor connected hardware or devices. Mainlogix has  other subsidiaries that focus on different sectors of Technology,Subsidiaries like Intelkard and  GrandeurSmart.

            </p>
            <br />
            <p>
              Mainlogix also offers IoT consulting services, hardware prototyping, IoT analytics, and IoT development. Our expertise extends across fields such as Industrial IoT, Smart Farming, Education, Hospitals, Hotels and Shortlets, Smart Cities, and Medical IoT.

            </p>

            <br />
          
            <img src={company} alt="office" />
          </div>
        
          <div >
            <img src={growth} alt="plant in vase" />
            <div>
              <br />
              <h3>Recent Developments</h3>
              <p>
              In 2024, Mainlogix proudly launched SMART, a cutting-edge AI voice assistant, in strategic partnership with Google and Alexa. SMART revolutionizes smart home management, seamlessly integrating with our mobile app, GrandeurSmart, available on Google and Alexa platforms. This innovative voice assistant empowers users to effortlessly control and command their smart devices, elevating the smart home experience to new heights.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Journey
